
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "ranking-teams",
    setup() {
        const route = useRoute();
        const { idevent, idsport } = route.params
        const loading = ref(false)
        const listRanking = ref<any>([])

        const getListRanking = async () => {
            loading.value = true
            await pservice.getRanking({
                    evento: idevent,
                    sport: idsport
                })
                .then((res) => {
                    listRanking.value = res.data
                    loading.value = false
                }).catch(({
                    response
                }) => {
                    loading.value = false
                })
        }

        onMounted(()=>{
            getListRanking()
        })

        return {
            loading,
            listRanking,
            getListRanking
        }


        
    },
})
